import { Link } from "react-router-dom";
import { ArrowRight, HeartPulse, ShieldCheck, Smile, Stethoscope, Eye, Leaf, Hospital, FlaskConical, Plane, TrendingUp, RefreshCw, Users, Building2 } from "lucide-react";
import { Container, PageFade, Reveal } from "../components/site/Motion";
import { PageHeader, TopicGrid } from "../components/site/Sections";
import { ConsultationSection } from "../components/site/ConsultationSection";

const COVERAGES = [
  { icon: ShieldCheck, t: "Assurance invalidité", d: "Une protection du revenu si une maladie ou un accident vous empêche de travailler." },
  { icon: HeartPulse, t: "Assurance vie", d: "Un soutien financier pour vos proches." },
  { icon: Smile, t: "Soins dentaires", d: "Une couverture pour les soins dentaires selon le régime choisi." },
  { icon: Plane, t: "Accident-maladie complémentaire", d: "Incluant l'assurance voyage." },
  { icon: Eye, t: "Soins de la vue", d: "Examens et lunettes, selon les modalités du contrat." },
  { icon: Leaf, t: "Médecines douces", d: "Massothérapie, physiothérapie et autres professionnels de la santé." },
  { icon: Hospital, t: "Hospitalisation", d: "Frais d'hospitalisation selon les conditions du contrat." },
  { icon: FlaskConical, t: "Frais de laboratoire", d: "Analyses et examens couverts selon le régime." },
];

const FEATURES = [
  { icon: Stethoscope, t: "Télémédecine", d: "Accès à des consultations médicales virtuelles en temps réel." },
  { icon: RefreshCw, t: "Renouvellement garanti", d: "Renouvellement du contrat garanti jusqu'à 65 ans, sous réserve des exceptions prévues." },
  { icon: TrendingUp, t: "Indexation des prestations", d: "Augmentation automatique selon l'IPC, sans preuve d'assurabilité, pour les assurés de moins de 55 ans." },
  { icon: Users, t: "Force du groupe", d: "Une stabilité appuyée par le pouvoir d'achat de l'ensemble des membres." },
];

const Eligibility = () => (
  <div className="grid gap-6 md:grid-cols-2">
    <Reveal className="card-soft p-8" >
      <Users className="h-7 w-7 text-[#650D23]" strokeWidth={1.5} />
      <h3 className="mt-4 text-2xl">À qui s'adresse le plan?</h3>
      <p className="mt-3 leading-relaxed text-[#242020]/80">Aux travailleurs autonomes, aux propriétaires d'entreprise, aux associés et à leurs employés permanents âgés de moins de 63 ans, qui remplissent les conditions d'assurabilité.</p>
    </Reveal>
    <Reveal delay={0.08} className="card-soft p-8">
      <Building2 className="h-7 w-7 text-[#650D23]" strokeWidth={1.5} />
      <h3 className="mt-4 text-2xl">Protection optionnelle : frais généraux</h3>
      <p className="mt-3 leading-relaxed text-[#242020]/80">Pour les entreprises de 10 employés et moins : une protection qui peut aider à couvrir les frais fixes de l'entreprise pendant une invalidité du propriétaire ou d'un associé.</p>
    </Reveal>
  </div>
);

export default function PlanCollectif() {
  return (
    <PageFade>
      <PageHeader eyebrow="Plan collectif hybride" title="Des protections de groupe," accent="pensées pour les entrepreneurs." image="/img/pont2_duo.jpg">
        <p className="max-w-xl text-lg text-[#242020]/80">Un programme de protections personnalisé pour les travailleurs autonomes et les petites entreprises : vous profitez d'avantages habituellement réservés aux grandes organisations, pour vous et votre équipe.</p>
        <Link to="/consultation" className="btn-primary" data-testid="collectif-cta">Parler à un conseiller <ArrowRight className="h-4 w-4" /></Link>
      </PageHeader>
      <Container className="py-16 lg:py-24">
        <Reveal><p className="eyebrow">Protections offertes</p><h2 className="mb-10 mt-4 text-3xl sm:text-4xl">Une couverture complète, en un seul programme</h2></Reveal>
        <TopicGrid items={COVERAGES} testid="collectif-coverages" />
      </Container>
      <section className="bg-[#FAF6F1]/90">
        <Container className="py-16 lg:py-24">
          <Reveal><h2 className="mb-10 text-3xl sm:text-4xl">Les avantages du programme</h2></Reveal>
          <TopicGrid items={FEATURES} testid="collectif-features" />
          <div className="mt-12"><Eligibility /></div>
        </Container>
      </section>
      <Container className="py-12">
        <p className="rounded-2xl border border-[#EDE3D9] bg-[#FFFDFB] p-6 text-sm leading-relaxed text-[#242020]/75" data-testid="collectif-disclaimer">
          Résumé informatif du programme offert par l'entremise du cabinet MRA. Ce résumé ne crée ni ne confère aucun droit contractuel : les stipulations du contrat émis par l'assureur prévalent, y compris les exclusions et limitations. La disponibilité de certaines protections peut varier d'une province à l'autre. Texte à valider avant publication.
        </p>
      </Container>
      <ConsultationSection />
    </PageFade>
  );
}
